import { render } from "./EditCharacterRole.vue?vue&type=template&id=20d0ff08"
import script from "./EditCharacterRole.vue?vue&type=script&lang=js"
export * from "./EditCharacterRole.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__